import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import resetStatePlugin from './resetStatePlugin'
import optimize from '@/store/optimize'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    last_activate_time: null,
    is_show_sidebar: true,
    is_show_drawer: true,
    device_type: 'desktop',
    redirected: false,
    old_setting_data: null,
    isLogged: false,
    login_info: null,
    selected_organize: null,
    selected_admin: null,
    selected_experience: null,
    auth_categories: null,
    selected_channel: null,
    selected_container: null,
    organize_container_mapper: {},
    register_token: null,
    mini_card_text: null,
    tab: 0,
    selected_marketing_card_container: null,
    is_auto_coupon: false,
    marketing_card_setting: null,
    container_items: null,

    warm_up_card_setting: null,
    activity_card_setting: null,
    end_up_card_setting: null,

    // 依會員等級有不同qouta
    member_quota: {},

    // 記錄該帳號目前的用量
    used_quantity: null,

    marketing_card: {
      is_auto_coupon: false,
      get_ele_innerHTML: false,

      mini_card_ele: '',
      card_content: '',
      desktop_card_hint: '',
      mobile_card_margin: '',
      mobile_card_padding: '',
      mobile_mini_card_margin: '',
      mobile_mini_card_padding: '',
      desktop_card_margin: '',
      add_column: '',
      container_id: '',

      /* tinymce輸入內容的變數 */
      tinymce_content: '<p>圖卡內文</p>',

      /* tinymce初始設定檔 */
      init: {
        selector: '#tinymce',
        language_url: '/tinymce/langs/zh_TW.js',
        language: 'zh_TW',
        skin_url: '/tinymce/skins/ui/oxide',
        height: '200px',
        branding: false,
        menubar: false,
        plugins: 'link',
        toolbar: 'undo redo| fontsizeselect | forecolor |  bold italic underline | link',
        content_style: 'p { margin:0px;padding:0px; line-height: 1.3;}',
      },

      /* 圖卡設定檔名稱 */
      setting_name: '',

      /* 圖卡預覽網址 */
      preview_url: '',

      /* 圖卡作用網域 */
      activate_domain: '',

      /* 圖卡作用優惠代碼 */
      activate_coupon: '',

      /* 開始時間 */
      start_at: '',

      /* 結束時間 */
      end_at: '',

      /* 是否自動帶入優惠代碼 */
      isAutoCoupon: false,

      /* 圖卡叉叉顏色 */
      card_close_color: '#000',

      /* 手機原始圖卡向下位移 */
      card_mobile_mg_top: '50',

      /* 手機縮小圖卡向下位移 */
      card_mobile_mini_mg_top: '50',

      /* 桌機原始圖卡向上位移 */
      card_desktop_mg_bottom: '10',

      /* 桌機原始圖卡向左位移 */
      card_desktop_mg_right: '10',

      /* 原始圖卡圖片 */
      card_img_src: 'https://pic.optimize99.com/api/img/_/cmp/1690251392463.jpg',

      /* 原始圖卡圖片背景顏色 */
      card_img_bg_color: '',

      /* 原始圖卡標題設定 */
      card_title: '圖卡標題',
      card_title_color: '#000',
      card_title_bg_color: '#ffffff',
      card_title_align: 'left',

      /* 原始圖卡行銷文字設定 */
      card_hint: '行銷文字',
      card_hint_color: '#000',
      card_hint_bg_color: '#ffffff',
      card_hint_align: 'center',

      /* 原始圖卡內文設定 */
      card_content_bg_color: '#ffffff',

      /* 桌機縮小圖卡設定 */
      desktop_mini_card_text: '桌機縮小的行銷文字',
      desktop_mini_card_color: '#ffffff',
      desktop_mini_card_bg_color: '#ffb3be',
      desktop_mini_card_align: 'center',
      desktop_mini_card_opacity: '',

      /* 手機縮小圖卡設定 */
      mini_card_text: '手機縮小的行銷文字',
      mini_card_color: '#ffffff',
      mini_card_bg_color: '#ffb3be',
      mini_card_align: 'center',
      mini_card_opacity: '',

      /* 設定檔資料庫id */
      setting_id: '',

      /* activate_domain 和 activate_coupon 檢查錯誤訊息 */
      message: '',

      /* 手機原始圖卡檢查錯誤訊息 */
      origin_card_message: '',

      /* 手機縮小圖卡檢查錯誤訊息 */
      mini_card_message: '',

      /* 桌機原始圖卡檢查錯誤訊息 */
      desktop_card_bottom_message: '',
      desktop_card_right_message: '',

      /* 倒數計時說明文字 */
      count_down_text: '限時倒數',
      count_down_text_bg_color: '#ffb3be',
      count_down_text_color: '#ff0f0f',

      //結尾
      count_down_text_end: '！',
      count_down_text_end_color: '#ff0f0f',

      count_down_d_text: '日',
      count_down_d_text_color: '#FFF',
      count_down_d_value_color: '#FFF',

      count_down_h_text: '小時',
      count_down_h_text_color: '#FFF',
      count_down_h_value_color: '#FFF',

      count_down_m_text: '分',
      count_down_m_text_color: '#FFF',
      count_down_m_value_color: '#FFF',

      count_down_s_text: '秒',
      count_down_s_text_color: '#FFF',
      count_down_s_value_color: '#FFF',

      /*  */
      mobile_mini_card_count_down_text: '▼',
      mobile_mini_card_count_down_text_color: '#000',
      mobile_mini_card_count_down_text_end: '▼',
      mobile_mini_card_count_down_text_end_color: '#000',
      desktop_mini_card_count_down_text: '▶',
      desktop_mini_card_count_down_text_color: '#000',
      desktop_mini_card_count_down_text_end: '▶',
      desktop_mini_card_count_down_text_end_color: '#000',

      // 重複輪迴日
      repeat_day: 0,

      editedCity: [],
      generalMarketingCard: false,
      cityMarketingCard: false,
      cityname: '',
      districtname: '',

      // 提示使用者之訊息
      return_msg: '請先選擇縣市再選擇行政區~',

      // 縣市或一般行銷圖卡的選擇，單選按鈕選定的值
      row: '',

      /* 設定檔圖卡tags */
      setting_tags: '',

      /* copy_mode = "on" */
      copy_setting_tags: '',

      // 倒數計時結束後要顯示的文字內容
      timer_off_text: '活動已結束',

      // 倒數計時結束後要顯示的文字顏色
      timer_off_text_color: '#ff0f0f',

      // 商品優惠價格字體大小
      discount_price_size: '',

      // 商品優惠價格
      discount_price: 'NT$',

      // 商品優惠價格顏色
      discount_price_color: '#ff0f0f',

      // 商品文字字體大小
      product_text_size: '',

      // 商品文字
      product_text: '',

      // 商品文字顏色
      product_text_color: '#ff0f0f',

      // 商品價格模式選擇
      product_mode: 0,

      // 活動開始時間
      campaign_start_at: '',

      // 活動結束時間
      campaign_end_at: '',

      // 圖片網址
      img_url: '',
    },

    // 要特別蓋過預設breadcrumbs的變數
    // 有可能某些breadcrumbs 要帶頁面的變數
    // e.g (設定 > 管理員 > watson)
    replace_breadcrumbs: [],
    is_page_loading: false,
    css_mapper: {
      font: {
        visible: true,
        block_title: '文字樣式',
        'font-size': {
          title: '大小',
          is_edit: false,
          icon: 'format_size',
          items: [
            {
              text: '12px',
              value: '12px',
            },
            {
              text: '13px',
              value: '13px',
            },
            {
              text: '14px',
              value: '14px',
            },
            {
              text: '15px',
              value: '15px',
            },
            {
              text: '16px',
              value: '16px',
            },
            {
              text: '17px',
              value: '17px',
            },
            {
              text: '18px',
              value: '18px',
            },
            {
              text: '19px',
              value: '19px',
            },
            {
              text: '20px',
              value: '20px',
            },
            {
              text: '21px',
              value: '21px',
            },
            {
              text: '22px',
              value: '22px',
            },
            {
              text: '23px',
              value: '23px',
            },
            {
              text: '24px',
              value: '24px',
            },
          ],
        },
        'font-weight': {
          title: '粗細',
          icon: 'format_bold',
          is_edit: false,
          item_mapper: {
            normal: '一般',
            bold: '粗體',
            lighter: '細體',
          },
          items: [
            {
              text: '一般',
              value: 'normal',
            },
            {
              text: '粗體',
              value: 'bold',
            },
            {
              text: '細體',
              value: 'lighter',
            },
          ],
        },
        'text-align': {
          title: '對齊方式',
          icon: 'format_align_left',
          is_edit: false,
          item_mapper: {
            left: '靠左',
            center: '置中',
            right: '靠右',
            justify: '左右對齊',
          },
          items: [
            {
              text: '靠左',
              value: 'left',
            },
            {
              text: '置中',
              value: 'center',
            },
            {
              text: '靠右',
              value: 'right',
            },
            {
              text: '左右對齊',
              value: 'justify',
            },
          ],
        },
        color: {
          title: '顏色',
          icon: 'format_color_text',
          is_open: false,
          is_edit: false,
        },
        'text-decoration': {
          title: '特效',
          icon: 'format_underlined',
          is_edit: false,
          item_mapper: {
            none: '無',
            underline: '底線',
            overline: '頂線',
            'line-through': '刪除線',
          },
          items: [
            {
              text: '無',
              value: 'none',
            },
            {
              text: '底線',
              value: 'underline',
            },
            {
              text: '頂線',
              value: 'overline',
            },
            {
              text: '刪除線',
              value: 'line-through',
            },
          ],
        },
        'line-height': {
          title: '行距',
          icon: 'format_line_spacing',
          is_edit: false,
          items: [
            {
              text: '10px',
              value: '10px',
            },
            {
              text: '11px',
              value: '11px',
            },
            {
              text: '12px',
              value: '12px',
            },
            {
              text: '13px',
              value: '13px',
            },
            {
              text: '14px',
              value: '14px',
            },
            {
              text: '15px',
              value: '15px',
            },
            {
              text: '16px',
              value: '16px',
            },
            {
              text: '17px',
              value: '17px',
            },
            {
              text: '18px',
              value: '18px',
            },
            {
              text: '19px',
              value: '19px',
            },
            {
              text: '20px',
              value: '20px',
            },
          ],
        },
        'letter-spacing': {
          title: '間距',
          icon: '',
          icon_2: 'mdi-format-letter-spacing',
          is_edit: false,
          items: [
            {
              text: '1px',
              value: '1px',
            },
            {
              text: '2px',
              value: '2px',
            },
            {
              text: '3px',
              value: '3px',
            },
            {
              text: '4px',
              value: '4px',
            },
            {
              text: '5px',
              value: '5px',
            },
            {
              text: '6px',
              value: '6px',
            },
            {
              text: '7px',
              value: '7px',
            },
            {
              text: '8px',
              value: '8px',
            },
            {
              text: '8px',
              value: '8px',
            },
            {
              text: '9px',
              value: '9px',
            },
            {
              text: '10px',
              value: '10px',
            },
          ],
        },
      },
      background: {
        visible: true,
        block_title: '背景樣式',
        'background-color': {
          title: '背景顏色',
          icon: 'format_color_fill',
          is_edit: false,
          is_open: false,
        },
      },
      border: {
        visible: true,
        block_title: '外框樣式',
        margin: {
          title: '外距',
          icon: 'select_all',
          is_edit: false,
          items: [
            {
              text: '1px',
              value: '1px',
            },
            {
              text: '2px',
              value: '2px',
            },
            {
              text: '3px',
              value: '3px',
            },
            {
              text: '4px',
              value: '4px',
            },
            {
              text: '5px',
              value: '5px',
            },
            {
              text: '6px',
              value: '6px',
            },
            {
              text: '7px',
              value: '7px',
            },
            {
              text: '8px',
              value: '8px',
            },
            {
              text: '8px',
              value: '8px',
            },
            {
              text: '9px',
              value: '9px',
            },
            {
              text: '10px',
              value: '10px',
            },
          ],
        },
        padding: {
          title: '內距',
          icon: 'border_clear',
          is_edit: false,
          items: [
            {
              text: '1px',
              value: '1px',
            },
            {
              text: '2px',
              value: '2px',
            },
            {
              text: '3px',
              value: '3px',
            },
            {
              text: '4px',
              value: '4px',
            },
            {
              text: '5px',
              value: '5px',
            },
            {
              text: '6px',
              value: '6px',
            },
            {
              text: '7px',
              value: '7px',
            },
            {
              text: '8px',
              value: '8px',
            },
            {
              text: '8px',
              value: '8px',
            },
            {
              text: '9px',
              value: '9px',
            },
            {
              text: '10px',
              value: '10px',
            },
          ],
        },
        'border-style': {
          title: '樣式',
          icon: 'border_clear',
          is_edit: false,
          items: [
            {
              text: 'none',
              value: 'none',
            },
            {
              text: 'solid',
              value: 'solid',
            },
            {
              text: 'dotted',
              value: 'dotted',
            },
            {
              text: 'dashed',
              value: 'dashed',
            },
            {
              text: 'hidden',
              value: 'hidden',
            },
            {
              text: 'double',
              value: 'double',
            },
            {
              text: 'groove',
              value: 'groove',
            },
            {
              text: 'ridge',
              value: 'ridge',
            },
            {
              text: 'inset',
              value: 'inset',
            },
            {
              text: 'outset',
              value: 'outset',
            },
          ],
        },
        'border-width': {
          title: '寬度',
          icon: 'border_outer',
          is_edit: false,
          items: [
            {
              text: '1px',
              value: '1px',
            },
            {
              text: '2px',
              value: '2px',
            },
            {
              text: '3px',
              value: '3px',
            },
            {
              text: '4px',
              value: '4px',
            },
            {
              text: '5px',
              value: '5px',
            },
            {
              text: '6px',
              value: '6px',
            },
            {
              text: '7px',
              value: '7px',
            },
            {
              text: '8px',
              value: '8px',
            },
            {
              text: '8px',
              value: '8px',
            },
            {
              text: '9px',
              value: '9px',
            },
            {
              text: '10px',
              value: '10px',
            },
          ],
        },
        'border-color': {
          title: '顏色',
          icon: 'border_color',
          is_edit: false,
          is_open: false,
        },
        'border-radius': {
          title: '圓角',
          icon: 'check_box_outline_blank',
          is_edit: false,
          items: [
            {
              text: '1px',
              value: '1px',
            },
            {
              text: '2px',
              value: '2px',
            },
            {
              text: '3px',
              value: '3px',
            },
            {
              text: '4px',
              value: '4px',
            },
            {
              text: '5px',
              value: '5px',
            },
            {
              text: '6px',
              value: '6px',
            },
            {
              text: '7px',
              value: '7px',
            },
            {
              text: '8px',
              value: '8px',
            },
            {
              text: '8px',
              value: '8px',
            },
            {
              text: '9px',
              value: '9px',
            },
            {
              text: '10px',
              value: '10px',
            },
          ],
        },
      },
      other_css: {
        visible: false,
        display: {
          title: '顯示',
        },
        width: {
          title: '寬度',
        },
        height: {
          title: '高度',
        },
        'margin-top': {
          title: 'margin-top',
        },
        'margin-bottom': {
          title: 'margin-top',
        },
        'justify-content': {
          title: '位置',
        },
        top: {
          title: 'top',
        },
        left: {
          title: 'left',
        },
        'mix-blend-mode': {
          title: 'mix-blend-mode',
        },
      },
    },
    attribute_mapper: {
      src: {
        is_edit: false,
        title: '來源',
      },
      href: {
        is_edit: false,
        title: '網址',
      },
    },
    selected_element_selector: '',
    selected_element_info: {},
    step_historys: [],
    step_history_index: -1,
    is_edit_text: false,
  },
  getters: {
    oldSettingData: (state) => {
      return state.old_setting_data
    },
    loggedStatus: (state) => {
      return state.isLogged
    },
    loggedInfo: (state) => {
      return state.login_info
    },
    selectedOrg: (state) => {
      return state.selected_organize
    },
    selectedAdmin: (state) => {
      return state.selected_admin
    },
    selectedExperience: (state) => {
      return state.selected_experience
    },
    authCategories: (state) => {
      return state.auth_categories
    },
    selectedChannel: (state) => {
      return state.selected_channel
    },
    selectedContainer: (state) => {
      return state.selected_container
    },
    registerToken: (state) => {
      return state.register_token
    },
    isAutoCoupon: (state) => {
      return state.marketing_card.is_auto_coupon
    },
    miniCardText: (state) => {
      return state.mini_card_text
    },
    startAt: (state) => {
      return state.marketing_card.start_at
    },
    campaignStartAt: (state) => {
      return state.marketing_card.campaign_start_at
    },
    endAt: (state) => {
      return state.marketing_card.end_at
    },
    campaignEndAt: (state) => {
      return state.marketing_card.campaign_end_at
    },
    repeatDay: (state) => {
      return state.marketing_card.repeat_day
    },
    marketing_card: (state) => {
      return state.marketing_card
    },
    tab: (state) => {
      return state.tab
    },
    selectedMarketingCardContainer: (state) => {
      return state.selected_marketing_card_container
    },
    marketingCardSetting: (state) => {
      return state.marketing_card_setting
    },
    containerItems: (state) => {
      return state.container_items
    },
    warmUpCardSetting: (state) => {
      return state.warm_up_card_setting
    },
    activityCardSetting: (state) => {
      return state.activity_card_setting
    },
    endUpCardSetting: (state) => {
      return state.end_up_card_setting
    },
    replace_breadcrumbs: (state) => {
      return state.replace_breadcrumbs
    },
    organize_container_mapper: (state) => {
      return state.organize_container_mapper
    },
    is_page_loading: (state) => {
      return state.is_page_loading
    },
    memberQuota: (state) => {
      return state.member_quota
    },
    is_show_sidebar: (state) => {
      return state.is_show_sidebar
    },
    is_show_drawer: (state) => {
      return state.is_show_drawer
    },
    device_type: (state) => {
      return state.device_type
    },
    css_mapper: (state) => {
      return state.css_mapper
    },
    attribute_mapper: (state) => {
      return state.attribute_mapper
    },
    selected_element_selector: (state) => {
      return state.selected_element_selector
    },
    selected_element_info: (state) => {
      return state.selected_element_info
    },
    step_historys: (state) => {
      return state.step_historys
    },
    step_history_index: (state) => {
      return state.step_history_index
    },
    is_edit_text: (state) => {
      return state.is_edit_text
    },
    usedQuantity: (state) => {
      return state.used_quantity
    },
    last_activate_time: (state) => {
      return state.last_activate_time
    },
  },
  mutations: {
    resetState() {
      localStorage.clear()
    },
    SET_REDIRECTED(state, redirected) {
      state.redirected = redirected
    },
    marketing_card_setting(state, marketing_card_setting) {
      state.marketing_card_setting = marketing_card_setting
    },
    update_warm_up_card_setting(state, newVal) {
      state.warm_up_card_setting = {
        ...state.warm_up_card_setting,
        ...newVal,
      }
    },
    warm_up_card_setting(state, warm_up_card_setting) {
      state.warm_up_card_setting = warm_up_card_setting
    },
    update_activity_card_setting(state, newVal) {
      state.activity_card_setting = {
        ...state.activity_card_setting,
        ...newVal,
      }
    },
    activity_card_setting(state, activity_card_setting) {
      state.activity_card_setting = activity_card_setting
    },
    update_end_up_card_setting(state, newVal) {
      state.end_up_card_setting = {
        ...state.end_up_card_setting,
        ...newVal,
      }
    },
    end_up_card_setting(state, end_up_card_setting) {
      state.end_up_card_setting = end_up_card_setting
    },
    update_marketing_card(state, newVal) {
      state.marketing_card = {
        ...state.marketing_card,
        ...newVal,
      }
    },
    update_old_setting_data(state, newVal) {
      state.old_setting_data = {
        ...state.old_setting_data,
        ...newVal,
      }
    },
    update_selected_experience(state, newVal) {
      state.selected_experience = {
        ...state.selected_experience,
        ...newVal,
      }
    },
    container_items(state, newVal) {
      state.container_items = newVal
    },
    old_setting_data: function (state, old_setting_data) {
      state.old_setting_data = old_setting_data
    },
    tab: function (state, tab) {
      state.tab = tab
    },
    login: function (state, login_info) {
      state.isLogged = true
      state.login_info = {
        ...state.login_info,
        ...login_info,
      }
    },
    select_organize: function (state, organize) {
      state.selected_organize = organize
    },
    logout: function (state) {
      ;(state.member_quota = null), (state.container_items = null)
      state.marketing_card_setting = null
      ;(state.selected_marketing_card_container = null),
        (state.mini_card_text = null),
        (state.campaign_end_at = null),
        (state.end_at = null),
        (state.isLogged = false)
      state.login_info = null
      ;(state.selected_organize = null),
        (state.selected_admin = null),
        (state.selected_experience = null),
        (state.auth_categories = null),
        (state.selected_channel = null),
        (state.selected_container = null),
        (state.register_token = null)
      ;(state.marketing_card = {
        /* tinymce輸入內容的變數 */
        tinymce_content: '<p>圖卡內文</p>',

        /* tinymce初始設定檔 */
        init: {
          selector: '#tinymce',
          language_url: '/tinymce/langs/zh_TW.js',
          language: 'zh_TW',
          skin_url: '/tinymce/skins/ui/oxide',
          height: '200px',
          branding: false,
          menubar: false,
          plugins: 'link',
          toolbar: 'undo redo| fontsizeselect | forecolor |  bold italic underline | link',
          content_style: 'p { margin:0px;padding:0px; line-height: 1.3;}',
        },

        /* 圖卡設定檔名稱 */
        setting_name: '',

        /* 圖卡預覽網址 */
        preview_url: '',

        /* 圖卡作用網域 */
        activate_domain: '',

        /* 圖卡作用優惠代碼 */
        activate_coupon: '',

        /* 開始時間 */
        start_at: '',

        /* 結束時間 */
        end_at: '',

        /* 是否自動帶入優惠代碼 */
        isAutoCoupon: false,

        /* 圖卡叉叉顏色 */
        card_close_color: '#000',

        /* 手機原始圖卡向下位移 */
        card_mobile_mg_top: '50',

        /* 手機縮小圖卡向下位移 */
        card_mobile_mini_mg_top: '50',

        /* 桌機原始圖卡向上位移 */
        card_desktop_mg_bottom: '10',

        /* 桌機原始圖卡向左位移 */
        card_desktop_mg_right: '10',

        /* 原始圖卡圖片 */
        card_img_src: 'https://pic.optimize99.com/api/img/_/cmp/1690251392463.jpg',

        /* 原始圖卡圖片背景顏色 */
        card_img_bg_color: '',

        /* 原始圖卡標題設定 */
        card_title: '圖卡標題',
        card_title_color: '#000',
        card_title_bg_color: '#ffffff',
        card_title_align: 'left',

        /* 原始圖卡行銷文字設定 */
        card_hint: '行銷文字',
        card_hint_color: '#000',
        card_hint_bg_color: '#ffffff',
        card_hint_align: 'center',

        /* 原始圖卡內文設定 */
        card_content_bg_color: '#ffffff',

        /* 桌機縮小圖卡設定 */
        desktop_mini_card_text: '桌機縮小的行銷文字',
        desktop_mini_card_color: '#ffffff',
        desktop_mini_card_bg_color: '#ffb3be',
        desktop_mini_card_align: 'center',
        desktop_mini_card_opacity: '',

        /* 手機縮小圖卡設定 */
        mini_card_text: '手機縮小的行銷文字',
        mini_card_color: '#ffffff',
        mini_card_bg_color: '#ffb3be',
        mini_card_align: 'center',
        mini_card_opacity: '',

        /* 設定檔資料庫id */
        setting_id: '',

        /* activate_domain 和 activate_coupon 檢查錯誤訊息 */
        message: '',

        /* 手機原始圖卡檢查錯誤訊息 */
        origin_card_message: '',

        /* 手機縮小圖卡檢查錯誤訊息 */
        mini_card_message: '',

        /* 桌機原始圖卡檢查錯誤訊息 */
        desktop_card_bottom_message: '',
        desktop_card_right_message: '',

        /* 倒數計時說明文字 */
        count_down_text: '限時倒數',
        count_down_text_bg_color: '#ffb3be',
        count_down_text_color: '#ff0f0f',

        //結尾
        count_down_text_end: '！',
        count_down_text_end_color: '#ff0f0f',

        count_down_d_text: '日',
        count_down_d_text_color: '#FFF',
        count_down_d_value_color: '#FFF',

        count_down_h_text: '小時',
        count_down_h_text_color: '#FFF',
        count_down_h_value_color: '#FFF',

        count_down_m_text: '分',
        count_down_m_text_color: '#FFF',
        count_down_m_value_color: '#FFF',

        count_down_s_text: '秒',
        count_down_s_text_color: '#FFF',
        count_down_s_value_color: '#FFF',

        /*  */
        mobile_mini_card_count_down_text: '▼',
        mobile_mini_card_count_down_text_color: '#000',
        mobile_mini_card_count_down_text_end: '▼',
        mobile_mini_card_count_down_text_end_color: '#000',
        desktop_mini_card_count_down_text: '▶',
        desktop_mini_card_count_down_text_color: '#000',
        desktop_mini_card_count_down_text_end: '▶',
        desktop_mini_card_count_down_text_end_color: '#000',

        // 重複輪迴日
        repeat_day: 0,

        editedCity: [],
        generalMarketingCard: false,
        cityMarketingCard: false,
        cityname: '',
        districtname: '',

        // 提示使用者之訊息
        return_msg: '請先選擇縣市再選擇行政區~',

        // 縣市或一般行銷圖卡的選擇，單選按鈕選定的值
        row: '',

        /* 設定檔圖卡tags */
        setting_tags: '',

        /* copy_mode = "on" */
        copy_setting_tags: '',

        // 倒數計時結束後要顯示的文字內容
        timer_off_text: '活動已結束',

        // 倒數計時結束後要顯示的文字顏色
        timer_off_text_color: '#ff0f0f',

        // 商品優惠價格字體大小
        discount_price_size: '',

        // 商品優惠價格
        discount_price: 'NT$',

        // 商品優惠價格顏色
        discount_price_color: '#ff0f0f',

        // 商品文字字體大小
        product_text_size: '',

        // 商品文字
        product_text: '',

        // 商品文字顏色
        product_text_color: '#ff0f0f',

        // 商品價格模式選擇
        product_mode: 0,

        // 活動開始時間
        campaign_start_at: '',

        // 活動結束時間
        campaign_end_at: '',

        // 圖片網址
        img_url: '',
      }),
        (state.is_auto_coupon = false)
    },
    selected_admin: function (state, selected_admin) {
      state.selected_admin = selected_admin
    },
    selected_experience: function (state, experience) {
      state.selected_experience = experience
    },
    auth_categories: function (state, auth_categories) {
      state.auth_categories = auth_categories
    },
    selected_channel: function (state, selected_channel) {
      state.selected_channel = selected_channel
    },
    selected_container: function (state, selected_container) {
      state.selected_container = selected_container
    },
    register_token: function (state, register_token) {
      state.register_token = register_token
    },
    is_auto_coupon: function (state, is_auto_coupon) {
      state.marketing_card.is_auto_coupon = is_auto_coupon
    },
    mini_card_text: function (state, mini_card_text) {
      state.mini_card_text = mini_card_text
    },
    start_at: function (state, start_at) {
      state.marketing_card.start_at = start_at
    },
    campaign_start_at: function (state, campaign_start_at) {
      state.marketing_card.campaign_start_at = campaign_start_at
    },
    end_at: function (state, end_at) {
      state.marketing_card.end_at = end_at
    },
    campaign_end_at: function (state, campaign_end_at) {
      state.marketing_card.campaign_end_at = campaign_end_at
    },
    repeat_day: function (state, repeat_day) {
      state.marketing_card.repeat_day = repeat_day
    },
    marketing_card: function (state, value) {
      // console.log('setter', state)
      // console.log('setter', value)
      state.marketing_card = value
      // state.marketing_card[key] = value
    },
    reset_marketing_card: function (state) {
      let param = {
        /* tinymce輸入內容的變數 */
        tinymce_content: '<p>圖卡內文</p>',

        /* tinymce初始設定檔 */
        init: {
          selector: '#tinymce',
          language_url: '/tinymce/langs/zh_TW.js',
          language: 'zh_TW',
          skin_url: '/tinymce/skins/ui/oxide',
          height: '200px',
          branding: false,
          menubar: false,
          plugins: 'link',
          toolbar: 'undo redo| fontsizeselect | forecolor |  bold italic underline | link',
          content_style: 'p { margin:0px;padding:0px; line-height: 1.3;}',
        },

        /* 圖卡設定檔名稱 */
        setting_name: '',

        /* 圖卡預覽網址 */
        preview_url: '',

        /* 圖卡作用網域 */
        activate_domain: '',

        /* 圖卡作用優惠代碼 */
        activate_coupon: '',

        /* 開始時間 */
        start_at: '',

        /* 結束時間 */
        end_at: '',

        /* 是否自動帶入優惠代碼 */
        auto_coupon: 0,

        /* 這其實是 是否顯示倒數計時器 */
        isAutoCoupon: false,

        /* 圖卡叉叉顏色 */
        card_close_color: '#000',

        /* 手機原始圖卡向下位移 */
        card_mobile_mg_top: '50',

        /* 手機縮小圖卡向下位移 */
        card_mobile_mini_mg_top: '50',

        /* 桌機原始圖卡向上位移 */
        card_desktop_mg_bottom: '10',

        /* 桌機原始圖卡向左位移 */
        card_desktop_mg_right: '10',

        /* 原始圖卡圖片 */
        card_img_src: 'https://pic.optimize99.com/api/img/_/cmp/1690251392463.jpg',

        /* 原始圖卡圖片背景顏色 */
        card_img_bg_color: '',

        /* 原始圖卡標題設定 */
        card_title: '圖卡標題',
        card_title_color: '#000',
        card_title_bg_color: '#ffffff',
        card_title_align: 'left',

        /* 原始圖卡行銷文字設定 */
        card_hint: '行銷文字',
        card_hint_color: '#000',
        card_hint_bg_color: '#ffffff',
        card_hint_align: 'center',

        /* 原始圖卡內文設定 */
        card_content_bg_color: '#ffffff',

        /* 桌機縮小圖卡設定 */
        desktop_mini_card_text: '桌機縮小的行銷文字',
        desktop_mini_card_color: '#ffffff',
        desktop_mini_card_bg_color: '#ffb3be',
        desktop_mini_card_align: 'center',
        desktop_mini_card_opacity: '',

        /* 手機縮小圖卡設定 */
        mini_card_text: '手機縮小的行銷文字',
        mini_card_color: '#ffffff',
        mini_card_bg_color: '#ffb3be',
        mini_card_align: 'center',
        mini_card_opacity: '',

        /* 設定檔資料庫id */
        setting_id: '',

        /* activate_domain 和 activate_coupon 檢查錯誤訊息 */
        message: '',

        /* 手機原始圖卡檢查錯誤訊息 */
        origin_card_message: '',

        /* 手機縮小圖卡檢查錯誤訊息 */
        mini_card_message: '',

        /* 桌機原始圖卡檢查錯誤訊息 */
        desktop_card_bottom_message: '',
        desktop_card_right_message: '',

        /* 倒數計時說明文字 */
        count_down_text: '限時倒數',
        count_down_text_bg_color: '#ffb3be',
        count_down_text_color: '#ff0f0f',

        //結尾
        count_down_text_end: '！',
        count_down_text_end_color: '#ff0f0f',

        count_down_d_text: '日',
        count_down_d_text_color: '#FFF',
        count_down_d_value_color: '#FFF',

        count_down_h_text: '小時',
        count_down_h_text_color: '#FFF',
        count_down_h_value_color: '#FFF',

        count_down_m_text: '分',
        count_down_m_text_color: '#FFF',
        count_down_m_value_color: '#FFF',

        count_down_s_text: '秒',
        count_down_s_text_color: '#FFF',
        count_down_s_value_color: '#FFF',

        /*  */
        mobile_mini_card_count_down_text: '▼',
        mobile_mini_card_count_down_text_color: '#000',
        mobile_mini_card_count_down_text_end: '▼',
        mobile_mini_card_count_down_text_end_color: '#000',
        desktop_mini_card_count_down_text: '▶',
        desktop_mini_card_count_down_text_color: '#000',
        desktop_mini_card_count_down_text_end: '▶',
        desktop_mini_card_count_down_text_end_color: '#000',

        // 重複輪迴日
        repeat_day: 0,

        editedCity: [],
        generalMarketingCard: false,
        cityMarketingCard: false,
        cityname: '',
        districtname: '',

        // 提示使用者之訊息
        return_msg: '請先選擇縣市再選擇行政區~',

        // 縣市或一般行銷圖卡的選擇，單選按鈕選定的值
        row: '',

        /* 設定檔圖卡tags */
        setting_tags: '',

        /* copy_mode = "on" */
        copy_setting_tags: '',

        // 倒數計時結束後要顯示的文字內容
        timer_off_text: '活動已結束',

        // 倒數計時結束後要顯示的文字顏色
        timer_off_text_color: '#ff0f0f',

        // 商品優惠價格字體大小
        discount_price_size: '',

        // 商品優惠價格
        discount_price: 'NT$',

        // 商品優惠價格顏色
        discount_price_color: '#ff0f0f',

        // 商品文字字體大小
        product_text_size: '',

        // 商品文字
        product_text: '',

        // 商品文字顏色
        product_text_color: '#ff0f0f',

        // 商品價格模式選擇
        product_mode: 0,

        // 活動開始時間
        campaign_start_at: '',

        // 活動結束時間
        campaign_end_at: '',

        // 圖片網址
        img_url: '',

        is_auto_coupon: false,

        get_ele_innerHTML: false,
      }

      state.marketing_card = param
    },
    selected_marketing_card_container: function (state, selected_marketing_card_container) {
      state.selected_marketing_card_container = selected_marketing_card_container
    },
    update_breadcrumbs: function (state, page_breadcrumbs) {
      state.replace_breadcrumbs = page_breadcrumbs
    },
    update_organize_container_mapper: function (state, organize_container_mapper) {
      state.organize_container_mapper = organize_container_mapper
    },
    update_is_page_loading: function (state, is_page_loading) {
      state.is_page_loading = is_page_loading
    },
    update_member_quota: function (state, member_quota) {
      let org_id = member_quota['org_id']
      let quota = member_quota['quota']
      state.member_quota[org_id] = quota
      console.log('set_quota', state.member_quota)
    },
    setIsShowSidebar: function (state, is_show_sidebar) {
      state.is_show_sidebar = is_show_sidebar
    },
    setIsShowDrawer: function (state, is_show_drawer) {
      state.is_show_drawer = is_show_drawer
    },
    setDeviceType(state, type) {
      state.device_type = type
    },
    setSelectedElementInfo(state, selected_element_info) {
      state.selected_element_info = selected_element_info
    },

    setSelectedElementSelector(state, selected_element_selector) {
      state.selected_element_selector = selected_element_selector
    },

    setStepHistorys(state, steps) {
      state.step_historys = steps
    },
    setHistoryIndex(state, idx) {
      state.step_history_index = idx
    },

    setIsEditText(state, is_edit_text) {
      state.is_edit_text = is_edit_text
    },

    setUsedQuantity(state, newVal) {
      state.used_quantity = {
        ...state.used_quantity,
        ...newVal,
      }
    },
    setLastActivateTime(state, last_activate_time) {
      state.last_activate_time = last_activate_time
    },
  },
  actions: {
    updateContainerId(context, { newContainerId, route, router }) {
      // 更新 container_id

      context.commit('SET_REDIRECTED', true)
      console.log(context)
      console.log(newContainerId)
      console.log(route)
      console.log(router)
      // 取得當前路由的路徑
      const currentPath = route

      // 從當前路由刪除舊的 container_id
      const basePath = currentPath.split('/').slice(2).join('/')

      // const toNewPath = route.replace(':container_id', newContainerId)

      // 導轉到新的路径
      // router.push(`/${newContainerId}/${basePath}`)
      return `/${newContainerId}/${basePath}`
    },
  },
  modules: {
    optimize,
  },
  plugins: [createPersistedState(), resetStatePlugin],
})
